<template>
  <DashboardHero :loading="loading">
    <template v-slot:title>Occupancy:</template>
    <template v-slot:value>
      {{ Number(data.occupancy).toFixed(2) }} %
    </template>
  </DashboardHero>
</template>

<script>
import axios from 'axios';
import DashboardHero from './DashboardHero';
import { UNITS_API_BASE } from '../env';

export default {
  name: 'FacilityOccupancy',
  props: {
    facility: { type: String, required: true },
  },
  components: { DashboardHero },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityOccupancy();
      this.loading = false;
    },
  },
  async mounted() {
    if (!this.facility) {
      return;
    }

    await this.getFacilityOccupancy();
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      data: {},
    };
  },
  methods: {
    async getFacilityOccupancy() {
      try {
        const response = await axios.get(`${UNITS_API_BASE}/dashboard/occupancy/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        const data = response.data.result;

        this.data = data;
      } catch (err) {
        this.$message({
          showClose: true,
          offset: 60,
          type: 'error',
          duration: 10000,
          message: err.response.data,
        });
      }
    },
  },
};
</script>

<style scoped>
.wallet-text {
  color: #efefef;
  font-weight: 300;
}

.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
.el-card__header {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityOccupancy.vue